module.exports = __webpack_public_path__ + "static/media/assitance.9c49d78f.png";